import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import baustein from "baustein";
import PropTypes from "prop-types";
import React from "react";

var Baustein =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Baustein, _React$PureComponent);

  function Baustein(props) {
    var _this;

    _classCallCheck(this, Baustein);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Baustein).call(this, props));

    _this.sanityCheckProps(props);
    /** @type React.RefObject<HTMLDivElement> */


    _this.el = React.createRef();
    /** @type baustein.Component | undefined */

    _this.binstance = undefined;
    /** @type baustein.Component[] */

    _this.subBintances = [];
    /** @type HTMLElement[] */

    _this.templateContents = [];
    _this.state = {
      hasStarted: false
    };
    return _this;
  }

  _createClass(Baustein, [{
    key: "sanityCheckProps",
    value: function sanityCheckProps(props) {
      if (!(props.template || props.component)) {
        throw new Error("Must specify template or component!");
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Extract our precious children
      if (!this.state.hasStarted && this.props.template && this.el.current) {
        var el = this.el.current;

        while (el.firstChild) {
          this.templateContents.push(el.removeChild(el.firstChild));
        }
      } // Tell React to render an empty div from now on


      this.setState({
        hasStarted: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyOldComponent();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.hasStarted != prevState.hasStarted) {
        // First pass, let's go
        this.createNewComponent();
      } else if (this.props.template != prevProps.template || this.props.component != prevProps.component) {
        // Our component has changed, make a new one
        this.sanityCheckProps(this.props);
        this.destroyOldComponent();
        this.createNewComponent();
      } else {
        // Our `args` prop has changed, tell baustein
        this.updateCurrentComponent();
      }
    }
  }, {
    key: "destroyOldComponent",
    value: function destroyOldComponent() {
      if (this.binstance) {
        this.binstance.destroy();
        this.binstance = undefined;
      }

      this.subBintances.forEach(function (binstance) {
        return binstance.destroy();
      });
      this.subBintances = [];
    }
  }, {
    key: "createNewComponent",
    value: function createNewComponent() {
      var el = this.el.current;

      if (!el) {
        throw new Error("This function can only be called after rendering has taken place!");
      }

      var _this$props = this.props,
          template = _this$props.template,
          component = _this$props.component,
          args = _this$props.args; // If we have an actual component, it'll entirely take care of its own DOM.
      // Otherwise, we'll need to create the HTML and then sideload a component into the existing Baustein structure.

      if (component) {
        this.binstance = new component(args);
        this.binstance.appendTo(el);
        return;
      } // If we've got a SSR version of the template, use that instead of making our own


      if (this.templateContents.length > 0) {
        this.templateContents.forEach(function (node) {
          return el.appendChild(node);
        });
        this.templateContents = [];
      } else {
        /** @type string */
        var tempHTML = template(args).trim();

        if (tempHTML === "") {
          // This is either a catastrophic error or intentional. Hopefully it's intentional
          console.warn("Blank template rendered by", template, "with args", args, "?");
          return;
        }

        el.innerHTML = tempHTML;
      } // Normally, the jinja template should render a single element, which is a baustein component


      var rootComponent;

      if (el.children.length == 1) {
        rootComponent = baustein.fromElement(el.children[0]);
      } // If it hasn't done that, it's presumably rendered a tree of components.
      // We can't really manange those, but let's keep track of them regardless


      var subComponents = [];

      if (!rootComponent) {
        subComponents = baustein.parse(el);
      } // This will happen if the template renders nothing but text, or something big is broken


      if (!rootComponent && subComponents.length == 0) {
        throw new Error("No Baustein components in the rendered template!");
      }

      this.binstance = rootComponent;
      this.subBintances = subComponents;
    }
  }, {
    key: "updateCurrentComponent",
    value: function updateCurrentComponent() {
      if (this.binstance) {
        this.binstance.updateOptions(this.props.args);
      }
    }
  }, {
    key: "render",
    value: function render() {
      /*
          In order to have the rendered HTML available for SEO we need to
          render the template on the server which unfortunately means React
          has to know about its contents.
          In order to avoid vdom diffing further up the line trashing
          everything, we need to render the template (both on the server
          and client) and then detach the nodes manually, render an empty
          div and then re-attach them invisibly.
          As long as we only ever tell React that we have an empty div, it
          will never go check what's actually there.
      */
      if (!this.state.hasStarted && this.props.template) {
        var _this$props2 = this.props,
            template = _this$props2.template,
            args = _this$props2.args;
        return React.createElement("div", {
          suppressHydrationWarning: true,
          className: this.props.className,
          ref: this.el,
          key: "unique",
          dangerouslySetInnerHTML: {
            __html: template(args).trim()
          }
        });
      }

      return React.createElement("div", {
        className: this.props.className,
        ref: this.el,
        key: "unique"
      });
    }
  }]);

  return Baustein;
}(React.PureComponent);

Baustein.propTypes = {
  args: PropTypes.object.isRequired,
  className: PropTypes.string,
  component: PropTypes.func,
  template: PropTypes.func
};
export default Baustein;